module.exports = __webpack_public_path__ + "img/vue-mk-header.b6674b36.jpg";